import { render, staticRenderFns } from "./Page8.vue?vue&type=template&id=0c0d71cb&scoped=true&"
import script from "./Page8.vue?vue&type=script&lang=ts&"
export * from "./Page8.vue?vue&type=script&lang=ts&"
import style0 from "./Page8.vue?vue&type=style&index=0&id=0c0d71cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d71cb",
  null
  
)

export default component.exports